import { Pipe, PipeTransform } from '@angular/core';
import { currency } from '@coworkrz/core/helpers/js';

@Pipe({
  name: 'currency',
  standalone: true,
})
export class CurrencyPipe implements PipeTransform {
  transform(price: number | string): string {
    return currency(price);
  }
}
